import { render } from "./HeaderFormEvent.vue?vue&type=template&id=ef73dfba&ts=true"
import script from "./HeaderFormEvent.vue?vue&type=script&lang=ts"
export * from "./HeaderFormEvent.vue?vue&type=script&lang=ts"

import "./HeaderFormEvent.vue?vue&type=style&index=0&id=ef73dfba&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__